module.exports = __webpack_public_path__ + "static/media/aleph.8b428dce.png";